export default "__VITE_ASSET__CB5DF9Xv__"